// IE 11 FIXES

/* eslint-disable
  no-native-reassign,
  no-global-assign,
  no-extend-native,
  no-prototype-builtins,
  no-var,
  prefer-arrow-callback,
  prefer-rest-params,
  one-var,
  wrap-iife,
  eslint-disable import/order
*/
import "core-js/stable/object/entries"; // WS V2
import "core-js/web";
import "core-js/stable/reflect";
import "svg-classlist-polyfill";

export const runPollyfills = () => {
  /* .prepend() polyfill */
  HTMLElement = typeof HTMLElement !== "undefined" ? HTMLElement : Element;
  if (!HTMLElement.prototype.prepend) {
    HTMLElement.prototype.prepend = function(element) {
      if (this.firstChild) {
        return this.insertBefore(element, this.firstChild);
      }
      return this.appendChild(element);
    };
  }

  /* .append() polyfill */
  (function(arr) {
    arr.forEach(function(item) {
      if (item.hasOwnProperty("append")) {
        return;
      }
      Object.defineProperty(item, "append", {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function append() {
          var argArr = Array.prototype.slice.call(arguments),
            docFrag = document.createDocumentFragment();

          argArr.forEach(function(argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });

          this.appendChild(docFrag);
        },
      });
    });
  })([Element.prototype, Document.prototype, DocumentFragment.prototype]);

  /* .remove() polyfill */
  (function(arr) {
    arr.forEach(function(item) {
      if (item.hasOwnProperty("remove")) {
        return;
      }
      Object.defineProperty(item, "remove", {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          this.parentNode.removeChild(this);
        },
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
};

export const bundleImport = (path, storieName, bundleName) => {
  return new Promise((resolve, reject) => {
    const js = document.createElement("script");
    js.type = "text/javascript";
    js.src = path;
    js.onload = () => {
      resolve(window[storieName] || window.zara.enhancements[bundleName]);
    };
    js.onerror = err => reject(err);
    document.head.appendChild(js);
  });
};
